import { FEATURES } from '../../values/features';
import './FeaturesSection.css';

const FeaturesSection = () => {
  return (
    <section className="caracteristicas">
      <div className="container">
        <h2>FUNCIONALIDADES DE NUESTRAS INVITACIONES</h2>
        <br />

        <div className="row">
          {FEATURES.map((feature) => (
            <div key={feature.id} className="col-6 col-md-3 item">
              <img src={feature.icon} alt={feature.title} />
              <h5>{feature.title}</h5>
              <p dangerouslySetInnerHTML={{ __html: feature.description.replace(/\n/g, '<br/>') }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
